<template>
  <div id="resume" class="resume" v-loading.body="loading">
    <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-document" style="padding-right:5px"></i>Резюме</span>
        <el-form :model="resume" :rules="mainRules" ref="resume" label-width="130px" style="height:100%">
          <div class="main-info-row">
            <div class="first-row">
              <div class="main-info">
                <el-card style="width:100%;height:100%;">
                  <div slot="header" class="clearfix">
                    <span style="line-height: 36px;">Основная информация</span>
                  </div>
                  <el-form-item label="Фамилия">
                    <el-input placeholder="Фамилия" v-model="resume.lastName" :disabled="true">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Имя">
                    <el-input placeholder="Имя" v-model="resume.firstName" :disabled="true">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Отчество">
                    <el-input placeholder="Отчество" v-model="resume.middleName" :disabled="true">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Дата рождения" prop="dateOfBirth">
                    <el-date-picker v-model="resume.dateOfBirth" format="dd.MM.yyyy" type="date" text="" placeholder="Выберите дату" style="width:100%;" @change="changeDateOfBirth" :disabled="isReadOnly">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="Гражданство" prop="citizenship">
                    <el-select v-model="resume.citizenship" placeholder="Выберите гражданство" style="width:100%;" @change="changeCitizenship" :disabled="isReadOnly">
                      <el-option
                        v-for="item in countries"
                        :key="item.code"
                        :label="item.label"
                        :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-card>
              </div>
              <div class="educations">
                <el-card style="width:100%;height:100%;">
                  <div slot="header" class="clearfix">
                    <span style="line-height: 36px;">Информация об образовании</span>
                    <span style="float:right;" v-if="!isReadOnly">
                      <el-tooltip class="item" effect="dark" content="Добавить сведения об образовании" placement="top">
                        <el-button type="primary" icon="el-icon-plus" class="control-button" style="width:60px;" @click="addEducation"></el-button>
                      </el-tooltip>
                      <el-dialog title="Сведения об образовании" :visible.sync="educationDialogFormVisible" @open="openEducation" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
                        <el-form :model="education" :rules="educationRules" ref="education" label-width="130px">
                          <el-form-item label="Направление" prop="activity">
                            <el-select v-model="education.activity" placeholder="Выберите направление" style="width:100%;" @change="changeActivity" filterable>
                              <el-option
                                v-for="item in activities"
                                :key="item.code"
                                :label="item.label"
                                :value="item.code">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="Специальность" prop="speciality">
                            <el-select v-model="education.speciality" placeholder="Выберите направление, а затем специальность" style="width:100%;" filterable>
                              <el-option
                                v-for="item in specialities"
                                :key="item.code"
                                :label="item.fullLabel"
                                :value="item.code">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="Квалификация" prop="qualification">
                            <el-tooltip class="item" effect="dark" content="Бакалавр, магистр, специалист..." placement="top">
                              <el-input placeholder="Введите квалификацию" v-model="education.qualification">
                              </el-input>
                            </el-tooltip>
                          </el-form-item>
                          <el-form-item label="Дата окончания" prop="dateFinish">
                            <el-date-picker v-model="education.dateFinish" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item label="Тип" prop="type">
                            <el-select v-model="education.type" placeholder="Выберите тип" style="width:100%;">
                              <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button type="primary" @click="acceptEducation">Применить</el-button>
                          <el-button @click="cancelEducation">Отмена</el-button>
                        </span>
                      </el-dialog>
                    </span>
                  </div>
                  <el-table
                    ref="educationData"
                    :data="educations"
                    highlight-current-row
                    v-bind:height="educationTableHeight"
                    @current-change="selectEducation"
                    style="width: 100%; height: 100%;" border="true" header-cell-class-name="default-header-color">
                    <el-table-column
                      property="activity"
                      label="Направление"
                      width="145"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.activityLabel" placement="top">
                          <span class="grid-text-overflow">{{ scope.row.activityLabel }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Специальность"
                      property="speciality"
                      width="145"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.specialityLabel" placement="top">
                          <span class="grid-text-overflow">{{ scope.row.specialityLabel }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Квалификация"
                      property="qualification"
                      width="125"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                         <el-tooltip class="item" effect="dark" :content="scope.row.qualification" placement="top">
                           <span class="grid-text-overflow">{{ scope.row.qualification }}</span>
                         </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Дата окончания"
                      property="dateFinish"
                      width="150"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <el-icon name="time"></el-icon>
                        <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateFinish)" placement="top">
                          <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDate(scope.row.dateFinish) }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Тип"
                      property="type"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="getLabelById(types, scope.row.type)" placement="top">
                          <span class="grid-text-overflow">{{ getLabelById(types, scope.row.type) }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Операции"
                      width="135"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <span v-if="!isReadOnly">
                          <el-button
                            size="mini"
                            icon="el-icon-edit"
                            @click="editEducation(scope.$index, scope.row)"></el-button>
                          <el-button
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            @click="deleteEducation(scope.$index, scope.row)"></el-button>
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>
              </div>
            </div>
            <div class="second-row">
              <el-card style="width:100%;height:100%;">
                <div slot="header" class="clearfix">
                  <span style="line-height: 36px;">Информация о трудовой деятельности</span>
                  <span style="float:right;" v-if="!isReadOnly">
                    <el-tooltip class="item" effect="dark" content="Добавить сведения о трудовой деятельности" placement="top">
                      <el-button type="primary" icon="el-icon-plus" class="control-button" style="width:60px;" @click="addJob"></el-button>
                    </el-tooltip>
                    <el-dialog title="Сведения о трудовой деятельности" :visible.sync="jobDialogFormVisible" size="small" @open="openJob" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
                      <el-form :model="job" :rules="jobRules" ref="job" label-width="100px">
                        <el-form-item label="С" prop="dateStart" style="width:100%;">
                          <el-col :span="6">
                            <el-date-picker v-model="job.dateStart" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату" style="width:200px;">
                            </el-date-picker>
                          </el-col>
                          <el-col class="line" :span="4" style="text-align:right;padding-right:15px;">по</el-col>
                          <el-col :span="6" style="">
                            <el-date-picker v-model="job.dateFinish" type="date" format="dd.MM.yyyy" text="" placeholder="Выберите дату" style="width:200px;" :disabled="disableToDate">
                            </el-date-picker>
                          </el-col>
                          <el-col class="line" style="text-align:right;" :span="7">по настоящее время</el-col>
                          <el-col :span="1">
                            <el-checkbox v-model="job.isPresent" style="float:right;" @change="changeTillNow"></el-checkbox>
                          </el-col>
                        </el-form-item>
                        <el-form-item label="Организация" prop="organisation">
                          <el-input placeholder="Введите организацию" v-model="job.organisation">
                          </el-input>
                        </el-form-item>
                        <el-form-item label="Должность" prop="position">
                          <el-input placeholder="Введите должность" v-model="job.position">
                          </el-input>
                        </el-form-item>
                        <el-form-item label="Страна" prop="country">
                          <el-select v-model="job.country" placeholder="Выберите страну" style="width:100%;">
                            <el-option
                              v-for="item in countries"
                              :key="item.code"
                              :label="item.label"
                              :value="item.code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                      <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="acceptJob">Применить</el-button>
                        <el-button @click="cancelJob">Отмена</el-button>
                      </span>
                    </el-dialog>
                  </span>
                </div>
                <div class="experience">
                  <el-form-item label="По специальности (с момента окончания учебного заведения)" label-position="top" label-width="300px" class="two-row-label">
                    <el-input-number  size="small" :min="0" :max="99" v-model="resume.yearsOfSpecialityExperience" style="width:120px;" @change="changeSpecialityExp" :disabled="isReadOnly">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="Гражданской (муниципальной) службы" label-width="300px" class="two-row-label">
                    <el-input-number size="small" :min="0" :max="99" v-model="resume.yearsOfCivilExperience" style="width:120px;" @change="changeEstateExp":disabled="isReadOnly">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="Военной (правоохранительной) службы" label-width="300px" class="two-row-label">
                    <el-input-number size="small" :min="0" :max="99" v-model="resume.yearsOfMilitaryExperience" style="width:120px;" @change="changeMilitaryExp" :disabled="isReadOnly">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="Общий стаж работы" label-width="300px" >
                    <el-input-number size="small" :min="0" :max="99" v-model="resume.yearsOfOverallExperience" style="width:120px;" @change="changeOverallExp" :disabled="isReadOnly">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="Предполагаемая должность" label-width="220px">
                    <el-select v-model="resume.expectedPosition" placeholder="Выберите должность" style="width:100%;" :disabled="disablePosition || isReadOnly" @change="changePosition">
                      <el-option
                        v-for="item in positions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="jobs">
                  <el-table
                    ref="jobsData"
                    :data="jobs"
                    highlight-current-row
                    v-bind:height="jobTableHeight"
                    @current-change="selectJob"
                    style="width: 100%; height: 100%;" border="true" header-cell-class-name="default-header-color">
                    <el-table-column
                      property="dateStart"
                      label="С"
                      width="150"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <el-icon name="time"></el-icon>
                        <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateStart)" placement="top">
                          <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDate(scope.row.dateStart) }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="По"
                      property="dateFinish"
                      width="150"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <el-icon name="time"></el-icon>
                        <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateFinish)" placement="top">
                          <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDate(scope.row.dateFinish) }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Организация"
                      property="organisation"
                      class="grid-text-overflow"
                      width="127">
                      <template slot-scope="scope">
                         <el-tooltip class="item" effect="dark" :content="scope.row.organisation" placement="top">
                           <span class="grid-text-overflow">{{ scope.row.organisation }}</span>
                         </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Должность"
                      property="position"
                      class="grid-text-overflow"
                      width="125">
                      <template slot-scope="scope">
                         <el-tooltip class="item" effect="dark" :content="scope.row.position" placement="top">
                           <span class="grid-text-overflow">{{ scope.row.position }}</span>
                         </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Страна"
                      property="country"
                      class="grid-text-overflow"
                      >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="getLabelByCode(countries, scope.row.country)" placement="top">
                          <span class="grid-text-overflow">{{ getLabelByCode(countries, scope.row.country) }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Операции"
                      width="135"
                      class="grid-text-overflow">
                      <template slot-scope="scope">
                        <span v-if="!isReadOnly">
                          <el-button
                            size="mini"
                            icon="el-icon-edit"
                            @click="editJob(scope.$index, scope.row)"></el-button>
                          <el-button
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            @click="deleteJob(scope.$index, scope.row)"></el-button>
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>
            </div>
          </div>
          <div class="floor-info">
            <el-card style="width:100%;height:100%;">
              <div slot="header" class="clearfix">
                <span style="line-height: 20px;">Дополнительная информация</span>
              </div>
              <el-form-item label="Комментарий">
                <el-input type="textarea" v-model="resume.comment" @change="changeComment" :disabled="isReadOnly"></el-input>
              </el-form-item>
              <span v-if="!isReadOnly">
                <p class="warning">
                  Обратите внимание, что данная форма не предназначена для приема обращений граждан.
                  Для направления обращения в электронной форме в адрес Администрации Ленинградской области используйте,
                  пожалуйста, адрес электронной почты priemnaya@lenreg.ru,
                  либо заполните форму обращения на сайте Администрации Ленинградской области www.lenobl.ru
                  в разделе 'Контакты', 'Написать письмо'.
                </p>
                <el-form-item style="margin-bottom: 0px !important;">
                  <el-checkbox v-model="resume.agreed" @change="changeAgreed">Я согласен на хранение и обработку моих персональных данных</el-checkbox>
                </el-form-item>
                <div style="width: 100%;margin-top:-5px;">
                  <el-button type="primary" icon="check" class="save-button" @click="save('resume')">Сохранить электронное резюме</el-button>
                </div>
              </span>
            </el-card>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :disabled="disableUpload" class="uploadTab" :style="uploadTabStyle">
        <span slot="label"><i class="el-icon-upload" style="padding-right:5px"></i> Документы</span>
        <div>
          <span v-if="!isReadOnly">
            <el-select v-model="documentsType" placeholder="Выберите категорию гражданина" style="width:300px;" @change="changeDocumentsType" filterable>
              <el-option
                v-for="item in documentTypes"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </span>
          <el-table
            ref="alreadyUploadedAttachments"
            :data="uploadedAttachments"
            style="width: 100%;"
            :height="uploadedAttachmentsTableHeight"
            :row-style="attachmentRowClass" border="true" header-cell-class-name="default-header-color">
            <el-table-column type="expand">
             <template slot-scope="props">
              <span v-if="props.row.urls && props.row.urls.length">
                <ul>
                  <b style="text-align: center">Формы для скачивания:</b>
                  <span v-for="item in props.row.urls">
                    <li>
                      <i class="el-icon-check" style="padding-right:10px"></i>
                      <a target="_blank" :href="item.url">
                        {{item.label}}
                      </a>
                    </li>
                  </span>
                </ul>
              </span>
              <span v-else>
                <b style="text-align: center">Формы для скачивания отсутствуют</b>
              </span>


              <span v-if="props.row.isAutoFillAvailable">
                <br>
                <!--<b style="text-align: center">Для того чтобы распечатать предзаполненный документ, нажмите <a target="_blank" href="../docviewer/0">здесь</a></b>-->
                <b style="text-align: center">Для того чтобы распечатать предзаполненный документ, нажмите <a target="_blank" @click="openDoc">здесь</a></b>
              </span>
             </template>
           </el-table-column>
            <el-table-column
              property="label"
              label="Тип"
              class="grid-text-overflow"
              width="210">
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.label }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              property="description"
              label="Описание"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <span style="width: 100%; text-align: justify; text-justify: inter-word;  white-space: normal; word-break: normal;">
                  {{ scope.row.description }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Дата загрузки"
              property="uploaded"
              width="150"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.uploaded)" placement="top">
                  <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDate(scope.row.uploaded) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Операции"
              width="250"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <span v-if="scope.row.isUploaded">
                  <el-button
                    size="mini"
                    icon="el-icon-upload2"
                    @click="downloadAttachment(scope.$index, scope.row)">Скачать</el-button>
                  <span v-if="!isReadOnly">
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="deleteAttachment(scope.$index, scope.row)">Удалить</el-button>
                  </span>
                </span>
                <span v-else>
                  <span v-if="!isReadOnly">
                    <el-button
                      size="mini"
                      icon="el-icon-upload"
                      @click="uploadAttachment(scope.$index, scope.row)">Загрузить</el-button>
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="Загрузка документа" :visible.sync="docDialogVisible" size="small" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
            <el-upload
              drag
              class="upload-demo"
              ref="upload"
              :action="uploadUrl"
              :headers="uploadRequestHeaders"
              :auto-upload="false"
              :fileList = "fileList"
              :before-upload="beforeUpload"
              :on-change="changeFileList"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              list-type="picture"
              style="width:100%; padding:10px;"
              >
              <i class="el-icon-upload" style="width:100%"></i>
              <div class="el-upload__text"><em>Нажмите на область для выбора файла</em></div>
              <div class="el-upload__tip" slot="tip" style="width:100%; text-align:center;">
                jpg/jpeg/png/pdf файлы размером меньше, чем 5MB
              </div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="acceptAttachment">Загрузить</el-button>
              <el-button @click="cancelAttachment">Отмена</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import grid from '../../api/helpers/grid'
  import layout from '../../api/helpers/layout'
  import rules from '../../api/rules/resume'
  import extension from '../../api/helpers/file'
  import html2pdf from 'html2pdf.js'
  import jsPDF from 'jspdf'

  export default {
    name: 'resume',
    props: ['guid'],
    data() {
      return {
        ///COMMON
        loading: true,
        isReadOnly: false,
        ///ARRAYS
        specialities: [],
        activities: [],
        countries: [],
        types: [],
        positions: [],
        ///RESUME
        resume: {
          comment:'',
          dateOfBirth: null,
          lastName: '',
          firstName: '',
          middleName: '',
          citizenship: null,
          yearsOfSpecialityExperience: 0,
          yearsOfCivilExperience: 0,
          yearsOfMilitaryExperience: 0,
          yearsOfOverallExperience: 0,
          expectedPosition: null,
          agreed: false,
          isAttachmentsUploadEnabled: false
        },
        documentsType: '1',
        copy: {
          dateOfBirth: null,
          citizenship: null,
          expectedPosition: null,
        },
        isDirty: false,
        ///EDUCATION
        educations: [],
        education: {
          speciality: '',
          specialityLabel: '',
          activity: '',
          activytLabel: '',
          dateFinish: null,
          qualification: '',
          type: null,
          isNew: true
        },
        selectedEducation: null,
        ///JOB
        jobs: [],
        job: {
          dateStart: null,
          dateFinish: null,
          organisation: '',
          position: '',
          country: null,
          isPresent: true,
          isNew: true
        },
        selectedJob: null,
        ///WINDOW
        educationResultsHeight: null,
        jobResultsHeight: null,
        uploadedAttachmentsResultsHeight: null,
        educationDialogFormVisible: false,
        jobDialogFormVisible: false,
        enablePosition: false,
        ///UPLOADS
        documentTypes: [
          { id: '1', label: 'Гражданин РФ'},
          { id: '2', label: 'Госслужащий РФ'}
        ],
        fileList: [],
        uploadUrl: `${config.API_PREFIX}resume/attachments`,
        uploadRequestHeaders: null,
        uploadedAttachments: [],
        attachmentToUpload: null,
        docDialogVisible: false,
        ///RULES
        fromDateRule: [
          { required: true, validator: (rule, value, callback) => {
              if(value) {
                let date = new Date();
                let fromDate = new Date(value);
                var dateFormat = require('dateformat');
                if(fromDate > date)
                  return callback(new Error('Дата начала работы не может быть больше сегодняшнего дня'));
                let toDate = null;
                if(this.job && this.job.finishDate)
                    toDate = this.job.finishDate;
                if(!toDate) {
                    toDate = new Date();
                    toDate.setFullYear(toDate.getFullYear() + 42);
                }
                if(fromDate >= toDate)
                  return callback("Дата окончания работы должна быть больше даты начала работы");
                date.setFullYear(date.getFullYear() - 42);
                //FROM
                if(fromDate >= date && toDate > fromDate) {
                  let maxToDate = new Date();
                  maxToDate.setFullYear(maxToDate.getFullYear() + 42);
                  //TO
                  if(!(toDate <= maxToDate && toDate > fromDate))
                    return callback(new Error('Дата окончания работы должна быть в промежутке от '+ dateFormat(fromDate, 'dd.mm.yyyy') + ' до ' + dateFormat(maxToDate, 'dd.mm.yyyy')));
                } else
                  return callback(new Error('Дата начала работы должна быть в промежутке от '+ dateFormat(date, 'dd.mm.yyyy') + ' до ' + dateFormat(toDate, 'dd.mm.yyyy')));
                return callback();
              } else
                return callback(new Error('Пожалуйста, введите дату начала работы'));
            }, trigger: 'change'}
        ]
      }
    },
    computed: {
      ///STYLES
      educationTableHeight: function() {
        if(!this.educationResultsHeight) {
          let height = layout.getParentClientHeight();
          if(height) {
            let twoRowHeight = height - 30 - 200;
            let percentage = 325 / twoRowHeight;
            this.educationResultsHeight = twoRowHeight * percentage - 40 - 17;
          }
        }
        return this.educationResultsHeight;
      },
      jobTableHeight: function() {
        if(!this.jobResultsHeight) {
          let height = layout.getParentClientHeight();
          if(height) {
            let twoRowHeight = height - 30 - 200;
            let percentage = 340 / twoRowHeight;
            this.jobResultsHeight = twoRowHeight * percentage - 40 - 17;
          }
        }
        return this.jobResultsHeight;
      },
      uploadedAttachmentsTableHeight: function() {
        if(!this.uploadedAttachmentsResultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            this.uploadedAttachmentsResultsHeight = height - 100 - 36;
        }
        return this.uploadedAttachmentsResultsHeight;
      },
      uploadTabStyle: function() {
          let height = layout.getParentClientHeight();
          if(height) {
            return "height:" + (height - 100) + "px";
          }
          return "height:500px";
      },
      disablePosition: function() {
        return !this.enablePosition;
      },
      disableToDate: function() {
        if(this.job)
          return this.job.isPresent;
        return false;
      },
      disableUpload: function() {
        return !(this.resume && this.resume.isAttachmentsUploadEnabled);
      },
      ///RULES
      mainRules: function() {
        return rules.getRules();
      },
      educationRules: function() {
        return rules.getEducationRules();
      },
      jobRules: function() {
        let jRules = rules.getJobRules();
        jRules.dateStart = this.fromDateRule;
        return jRules;
      }
    },
    methods: {
      save(form) {
        if(!this.resume.agreed) {
          this.$alert('Для сохранения анкеты необходимо дать согласие на хранение и обработку персональных данных', 'Предупреждение', {
            confirmButtonText: 'OK',
            type: 'warning',
            callback: action => {

            }
          });
        } else if (!this.educations || this.educations.length === 0) {
          this.$alert('Должна быть хотя бы одна запись в сведениях об образовании', 'Предупреждение', {
            confirmButtonText: 'OK',
            type: 'warning',
            callback: action => {

            }
          });
        } else {
          this.$refs[form].validate((valid) => {
            if (valid) {
              let self = this;
              let prefix = config.API_PREFIX;
              this.$gf.getOptions().then(options => {
                this.loading = true;
                options.params = {
                };
                this.resume.education = this.educations;
                this.resume.workExperience = this.jobs;
                self.$http.put(`${prefix}resume/`, this.resume, options)
                  .then(response => {
                    let isAttachmentsUploadEnabled = response.data.isAttachmentsUploadEnabled;
                    this.resume.isAttachmentsUploadEnabled = isAttachmentsUploadEnabled;
                    this.loading = false;
                    this.isDirty = false;
                    this.$alert('Резюме было успешно сохранено', 'Информация', {
                      confirmButtonText: 'OK',
                      type: 'success',
                      callback: action => {

                      }
                    });
                  })
                  .catch(data =>  {
                    this.loading = false;
                    self.$gf.checkError(data);
                  });
                }).catch(err => {
                  this.loading = false;
                  this.$gf.catchOptions()
                });
            }
          });
        }
      },
      ///EDUCATION
      selectEducation(val) {
        if(val)
          this.selectedEducation = val;
      },
      openEducation() {
        //this.$refs['education'].resetFields();
        if(this.selectedEducation) {
          let speciality = this.selectedEducation.speciality;
          this.changeActivity(this.selectedEducation.activity);
          this.education.speciality = speciality;
        }
      },
      addEducation() {
        this.resetEducation();
        this.educationDialogFormVisible = true;
      },
      acceptEducation() {
        this.$refs['education'].validate((valid) => {
          if (valid) {
            if(this.education && this.educations) {
              this.isDirty = true;
              this.education.activityLabel = this.getLabelByCode(this.activities, this.education.activity);
              this.education.specialityLabel = this.getLabelByCode(this.specialities, this.education.speciality);
              if(this.education.isNew) {
                  this.educations.push(this.education);
              } else {
                  if(this.selectedEducation) {
                    grid.assign(this.selectedEducation, this.education);
                  }
              }
            }
            this.educationDialogFormVisible = false;
          }
        });
      },
      cancelEducation() {
        this.educationDialogFormVisible = false;
      },
      editEducation(index, row) {
        this.resetEducation();
        this.selectedEducation = row;
        grid.assign(this.education, row);
        this.education.isNew = false;
        this.educationDialogFormVisible = true;
      },
      deleteEducation(index, row) {
        this.$confirm('Вы действительно хотите удалить запись', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          this.isDirty = true;
          if(this.educations)
            this.educations.splice(index, 1);
        }).catch(() => {

        });
      },
      resetEducation() {
        this.education = {
          speciality: '',
          specialityLabel: '',
          activity: '',
          activityLabel: '',
          dateFinish: null,
          qualification: '',
          type: null,
          isNew: true
        };
      },
      ///JOB
      selectJob(val) {
        if(val)
          this.selectedJob = val;
      },
      addJob() {
        this.resetJob();
        this.jobDialogFormVisible = true;
      },
      editJob(index, row) {
        this.resetJob();
        grid.assign(this.job, row);
        this.job.isNew = false;
        this.jobDialogFormVisible = true;
      },
      deleteJob(index, row) {
        this.$confirm('Вы действительно хотите удалить запись', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          this.isDirty = true;
          if(this.jobs)
            this.jobs.splice(index, 1);
        }).catch(() => {

        });
      },
      openJob() {
        //this.$refs['job'].resetFields();
        this.changeTillNow();
      },
      acceptJob() {
        this.$refs['job'].validate((valid) => {
          if (valid) {
            if(this.job && this.jobs) {
              this.isDirty = true;
              if(this.job.isNew) {
                  this.jobs.push(this.job);
              } else {
                  if(this.selectedJob)
                    grid.assign(this.selectedJob, this.job);
              }
            }
            this.jobDialogFormVisible = false;
          }
        });
      },
      cancelJob() {
        this.jobDialogFormVisible = false;
      },
      resetJob() {
        this.job = {
          dateStart: null,
          dateFinish: null,
          organisation: '',
          position: '',
          country: null,
          isPresent: true,
          isNew: true
        };
      },
      openDoc() {
        this.$router.push(config.DOC_VIEWER_URL + '/0');
      },
      ///CHANGE LISTENERS
      changeActivity(value) {
        this.education.speciality = '';
        let self = this;
        self.specialities = [];
        if(value) {
          this.loading = true;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = {
            };
            ///SPECIALITIES
            self.$http.get(`${prefix}resume/specs?code=`+value, options)
              .then(response => {
                this.loading = false;
                self.specialities = response.data;
              })
              .catch(data => {
                this.loading = false;
                self.specialities = [];
                self.$gf.checkError(data)
              });
          }).catch(err => {
            this.loading = false;
            self.specialities = [];
            this.$gf.catchOptions()
          });
        }
      },
      changeSpecialityExp(value) {
        if(this.resume) {
          this.isDirty = true && !this.loading;
          if(value)
            this.resume.yearsOfSpecialityExperience = value;
          else
            this.resume.yearsOfSpecialityExperience = 0;
        }
        this.changeExp(false);
      },
      changeEstateExp(value) {
        if(this.resume) {
          this.isDirty = true && !this.loading;
          if(value)
            this.resume.yearsOfCivilExperience = value;
          else
            this.resume.yearsOfCivilExperience = 0;
        }
        this.changeExp(false);
      },
      changeMilitaryExp(value) {
        if(this.resume) {
          this.isDirty = true && !this.loading;
          if(value)
            this.resume.yearsOfMilitaryExperience = value;
          else
            this.resume.yearsOfMilitaryExperience = 0;
        }
        this.changeExp(false);
      },
      changeOverallExp(value) {
        this.isDirty = true;
      },
      changeExp(fromProcessResponse) {
        if(this.resume && ((this.resume.yearsOfSpecialityExperience && this.resume.yearsOfSpecialityExperience > 0) || (this.resume.yearsOfCivilExperience && this.resume.yearsOfCivilExperience > 0) || (this.resume.yearsOfMilitaryExperience && this.resume.yearsOfMilitaryExperience > 0))) {
          this.enablePosition = true;
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = {
            };
            self.$http.get(`${prefix}resume/positions?yearsGGS=${this.resume.yearsOfCivilExperience}&yearsSpec=${this.resume.yearsOfSpecialityExperience}`, options)
              .then(response => {
                self.positions = response.data;
                this.setPosition(fromProcessResponse);
              })
              .catch(data => self.$gf.checkError(data));
              }).catch(err => this.$gf.catchOptions());
        } else {
          this.enablePosition = false;
          this.positions = [];
          this.setPosition(fromProcessResponse);
        }
      },
      changeDocumentsType(value) {
        this.fetchAttachments(this.guid);
      },
      setPosition(fromProcessResponse) {
        if(this.resume && this.resume.expectedPosition) {
          if(this.positions) {
            let result = this.positions.find( a => { return a.id === this.resume.expectedPosition; });
            if(!result) {
              this.resume.expectedPosition = null;
            }
          } else {
            this.resume.expectedPosition = null;
          }
          if(fromProcessResponse)
             this.isDirty = false;
        }
      },
      changeTillNow() {
        if(this.job) {
          if(this.job.isPresent)
            this.job.dateFinish = null;
        }
      },
      changeComment(value) {
        this.isDirty = true;
      },
      changeAgreed(value) {
        this.isDirty = true;
      },
      changeCitizenship(value) {
        this.isDirty = true && !(this.copy.citizenship === this.resume.citizenship);
      },
      changeDateOfBirth(value) {
        this.isDirty = true && !(this.copy.dateOfBirth === this.resume.dateOfBirth);
      },
      changePosition(value) {
        this.isDirty = true && !(this.copy.expectedPosition === this.resume.expectedPosition);
      },
      ///UPLOADS
      fetchAttachments(guid) {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = { };
          let type = this.documentsType;
          let get = this.isReadOnly ? `${prefix}candidatesview/${guid}/attachments` : `${prefix}resume/attachments/?type=`+type;
          self.$http.get(get, options)
            .then(response => {
              this.uploadedAttachments = response.data;
            })
            .catch(data => self.$gf.checkError(data));
          }).catch(err => this.$gf.catchOptions());
      },
      downloadAttachment(index, row) {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = { };
          let url = this.isReadOnly ? `candidatesview` : 'resume';
          self.$http.get(`${prefix}${url}/attachments/${row.uid}`, options)
            .then(response => {
              window.location.href = `${prefix}${url}/attachments/${row.uid}/${response.data}`;
            })
            .catch(data => self.$gf.checkError(data));
          }).catch(err => this.$gf.catchOptions());
      },
      deleteAttachment(index, row) {
        this.$confirm('Вы действительно хотите удалить загруженное вложение?', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = { };
            self.$http.delete(`${prefix}resume/attachments/${row.uid}`, options)
              .then(response => {
                this.fetchAttachments(null);
              })
              .catch(data => self.$gf.checkError(data));
            }).catch(err => this.$gf.catchOptions());
        }).catch(() => {

        });
      },
      uploadAttachment(index, row) {
        this.fileList = [];
        this.attachmentToUpload = row;
        this.showUpload();
      },
      acceptAttachment() {
        this.uploadDocs();
      },
      cancelAttachment() {
        this.fileList = [];
        this.attachmentToUpload = null;
        this.docDialogVisible = false;
      },
      showUpload() {
        if(!this.disableUpload) {
          this.$gf.getOptions()
            .then(options => {
                this.uploadRequestHeaders = options.headers;
                this.uploadRequestHeaders['DocumentType'] = this.attachmentToUpload.type;
                this.docDialogVisible = true;
            })
            .catch(data => {
                this.$gf.checkError(data)
            });
          }
      },
      uploadDocs() {
        this.loading = true;
        this.$refs.upload.submit();
        this.loading = false;
      },
      uploadSuccess(response, file, fileList) {
        this.loading = true;
        this.fetchAttachments(this.guid);
        this.fileList = [];
        this.attachmentToUpload = null;
        this.docDialogVisible = false;
        this.loading = false;
      },
      uploadError(err, file, fileList) {
        this.loading = false;
      },
      beforeUpload(file) {
        let ext = extension.getExtension(file.name);
        ext = ext ? ext.toLowerCase() : ext;
        const isImage = ext && (ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'pdf');
        const isLt5Mb = file.size / 1024 / 1024 <= 5;
        if (!isImage) {
          this.$message.error('Документ должен быть в формате jpg/jpeg/png/pdf');
        }
        if (!isLt5Mb) {
          this.$message.error('Размер документа должен быть меньше 5MB');
        }
        return isImage && isLt5Mb;
      },
      changeFileList(file, fileList) {
        let add = this.beforeUpload(file);
        if(!add) {
          fileList.splice(-1, 1);
        } else {
          if(fileList && fileList.length > 1) {
              this.$message.error('Количество документов не должно превышать 1');
              fileList.splice(-1, 1);
          }
        }
      },
      fetchData(guid) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          let contextPath = this.isReadOnly ? 'candidatesview' : 'resume';
          ///COUNTRIES
          self.$http.get(`${prefix}${contextPath}/countries`, options)
            .then(response => {
              self.countries = response.data;
            })
            .catch(data => self.$gf.checkError(data));
          ///ACTIVITIES
          self.$http.get(`${prefix}${contextPath}/activities`, options)
            .then(response => {
              self.activities = response.data;
            })
            .catch(data => self.$gf.checkError(data));
          ///EDUCATIONTYPES
          self.$http.get(`${prefix}${contextPath}/educationtypes`, options)
            .then(response => {
              self.types = response.data;
            })
            .catch(data => self.$gf.checkError(data));
          ///RESUME
          let getResume = this.isReadOnly ? 'candidatesview/' + guid : 'resume';
          self.$http.get(`${prefix}${getResume}`, options)
            .then(response => {
              this.processResponse(response);
            })
            .catch(data => { if(data.status === 404 && !this.isReadOnly) {
              this.$gf.getOptions().then(options => {
                options.params = {
              };
              self.$http.post(`${prefix}resume`,[], options).then(response => {
                this.processResponse(response);
              }).catch(data => self.$gf.checkError(data));
            });
          }});
        }).catch(err => this.$gf.catchOptions());

      },
      processResponse(response) {
        if(response) {
          let data = response.data;
          this.resume = data;
          this.documentsType = '1';
          if(data) {
            this.copy.citizenship = data.citizenship;
            this.copy.dateOfBirth = data.dateOfBirth;
            this.copy.expectedPosition = data.expectedPosition;
          }
          this.changeExp(true);
          if(data) {
            this.educations = data.education;
            this.jobs = data.workExperience;
          }
          this.loading = false;
        }
      },
      openDoc() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///DOC
          //let url = `${prefix}vacancy/08d58cf3-d5f4-ce72-86ed-496a222622ab/candidates/5a6889ca-dd10-4c40-bbc2-8e6ab2c52f89/resume`;
          let url = `${prefix}resume/questionnaire`;
          if(url) {
            self.$http.get(url, options)
              .then(response => {
                let rawHtml = response.data;
                self.loading = false;
                //setTimeout(window.print, 1000);

            	  var pdf = new jsPDF('p', 'pt', 'letter');
                pdf.filename = 'Анкета.pdf';
                pdf.margin = [10, 10, 10, 10];

            	  /*pdf.canvas.height = 72 * 11;
            	  pdf.canvas.width = 72 * 8.5;*/
            	  html2pdf(rawHtml, pdf, function(pdf){
                    self.loading = true;
                    pdf.save();
                    self.loading = false;
            	  });
                /*pdf.addHTML(rawHtml, 10, 10,
                  {pagesplit: true, margin: {top: 10, right: 10, bottom: 10, left: 10, useFor: 'content'}},
                  function () {pdf.save("test.pdf")})*/

              })
              .catch(data => {
                self.$gf.checkError(data);
                self.loading = false;
              });
          }
          self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      ///COMMON
      getLabelById(array, id) {
        return grid.getLabelById(array, id);
      },
      getLabelByCode(array, code) {
        return grid.getLabelByCode(array, code);
      },
      formatDate(d) {
        return grid.formatDate(d);
      },
      ///WINDOW
      resize() {
        let height = layout.getParentClientHeight();
        if(height) {
          let twoRowHeight = height - 30 - 200;
          let percentage1 = 325 / twoRowHeight;
          let percentage2 = 340 / twoRowHeight;
          this.educationResultsHeight = twoRowHeight * percentage1 - 40 - 17;
          this.jobResultsHeight = twoRowHeight * percentage2 - 40 - 17;
          this.uploadedAttachmentsResultsHeight = height - 100 - 36;
        }
        else {
          this.jobResultsHeight = null;
          this.educationResultsHeight = null;
          this.uploadedAttachmentsResultsHeight = null;
        }
      },
      attachmentRowClass(row, rowIndex) {
        if(row) {
          let status = row.isMandatory;
          if(status) {
            //return 'background-color:#fee';
          }
        }
        return 'background-color:#fff';
      },
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resize);
    },
    created: function () {
      window.addEventListener('resize', this.resize);
      if(this.guid)
        this.isReadOnly = true;
      this.fetchData(this.guid);
      this.fetchAttachments(this.guid);
    },
    beforeRouteLeave: function (to, from, next) {
      if(this.isDirty) {
        this.$confirm('Вы действительно хотите уйти с этой страницы? Все несохраненные данные будут потеряны', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          next();
        }).catch(() => {
          next(false);
          Event.$emit('stayOnResume');
        });
      } else {
        next();
      }
    }
  }
</script>

<style scoped>
  .resume {
    height: calc(100% - 20px);
    /*background: #eef1f6;
    border: 1px solid #d1dbe5;*/
    overflow-y: scroll;
  }
  .uploadArea {
    height: calc(100% - 230px);
  }
  .first-row {
    height: 340px;
  }
  .main-info {
    height: 100%;
    width: 450px;
    float: left;
  }
  .educations {
    height: 100%;
    width: calc(100% - 450px);
    float: left;
  }
  .second-row {
    /*height: calc(100% - 325px);*/
    height: 340px;
    width: 100%;
  }
  .main-info-row {
    /*height: calc(100% - 200px);*/
    height: 680px;
  }
  .floor-info {
    width: 100%;
    height: 250px;
  }
  .experience {
    height: 100%;
    width: 440px;
    float: left;
  }
  .jobs {
    height: 100%;
    width: calc(100% - 440px);
    padding-left: 12px;
    float: right;
  }
  .warning {
    font-size:14px;
    color:#48576a;
    margin-top:-20px;
    text-indent: 29px;
    text-align: justify;
    text-justify: inter-word;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  .clearfix:after {
      clear: both
  }
  .grid-text-overflow {
    /*overflow:hidden;
    display:inline-block;*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .control-button {
    width: 51px;
  }
  .save-button {
    width: 300px;
    display: table;
    margin: 0 auto;
  }
  .upload-button {
    width: 300px;
    display: table;
    margin: 0 auto;
  }
  .upload-card {
    border: 1px solid #d1dbe5;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);
    width: 100%;
  }
  .tooltip-item {
    width: 500px !important;
  }
  .mandatory-doc {
    background: #fee;
  }
</style>
<style>
  .el-card__header {
    padding: 4px 5px !important;
  }
  .el-card__body {
    padding: 5px !important;
  }
  .el-picker-panel {
    min-width: 350px !important;
  }

  .main-info .el-form-item,
  .experience .el-form-item {
    margin-bottom: 10px !important;
  }
  .main-info .el-form-item__label,
  .experience .el-form-item__label {
    line-height: 30px !important;
  }
  .two-row-label .el-form-item__label {
    margin-top: 0px !important;
  }
  .top-label .el-form-item__label {
    display: inline-block !important;
    float: none !important;
    text-align: center !important;
    width: 100% !important;
  }
  .top-label > * {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .top-label {
    margin-top: -10px !important;
  }
  .el-upload {
    width: 100% !important;
  }
  .el-upload-dragger {
    width: 100% !important;
    min-width: 360px !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/personalarea/resume.vue